import { render, staticRenderFns } from "./LinkFileFormat.vue?vue&type=template&id=581c8991&"
import script from "./LinkFileFormat.vue?vue&type=script&lang=ts&"
export * from "./LinkFileFormat.vue?vue&type=script&lang=ts&"
import style0 from "./LinkFileFormat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports